import React, { useState, useEffect, useRef } from 'react';
import { Menu, Bell, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Topbar.css';
import { API_BASE_URL } from '../global';

export default function Topbar({ toggleSidebar }) {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({ nome: 'Carregando...', foto_url: '' });
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef(null);
  const unreadCount = notifications.filter(n => parseInt(n.lida) === 0).length;

  const fetchProfile = async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) return;
    try {
      const response = await fetch(`${API_BASE_URL}/usuarios.php?id=${userId}`);
      const data = await response.json();
      if (data && data.length > 0) {
        setProfile(data[0]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchNotifications = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/notificacoes.php`);
      const data = await response.json();
      if (Array.isArray(data)) setNotifications(data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/notificacoes.php`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      const data = await res.json();
      if (data.success) {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, lida: 1 } : n));
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchNotifications();
    window.addEventListener('profileUpdated', fetchProfile);
    // Poll notifications every 30 seconds
    const intervalId = setInterval(fetchNotifications, 30000);
    
    // Close dropdown on outside click
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('profileUpdated', fetchProfile);
      clearInterval(intervalId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="icon-button" onClick={toggleSidebar} aria-label="Toggle Sidebar">
          <Menu size={24} />
        </button>
      </div>
      
      <div className="topbar-right">
        
        {/* Notificações */}
        <div style={{ position: 'relative' }} ref={dropdownRef}>
          <button className="icon-button" onClick={() => setShowNotifications(!showNotifications)}>
            <Bell size={20} />
            {unreadCount > 0 && <span className="notification-badge"></span>}
          </button>
          
          {showNotifications && (
            <div className="notifications-dropdown">
              <div className="notifications-header">
                <h4>Notificações</h4>
                <span className="text-muted">{unreadCount} não lidas</span>
              </div>
              <div className="notifications-body">
                {notifications.length === 0 ? (
                  <div className="notification-empty">Sem notificações</div>
                ) : (
                  notifications.map(notif => (
                    <div 
                      key={notif.id} 
                      className={`notification-item ${parseInt(notif.lida) === 0 ? 'unread' : ''}`}
                      onClick={() => {
                        if (parseInt(notif.lida) === 0) handleMarkAsRead(notif.id);
                      }}
                    >
                      <div className="notif-title">{notif.titulo}</div>
                      <div className="notif-msg">{notif.mensagem}</div>
                      <div className="notif-date">{new Date(notif.data_criacao).toLocaleString('pt-BR')}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

        <div 
          className="user-profile" 
          onClick={() => navigate('/configuracoes')} 
          style={{ cursor: 'pointer', transition: 'opacity 0.2s' }}
          onMouseOver={(e) => e.currentTarget.style.opacity = '0.8'}
          onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
        >
          <div className="avatar" style={{ overflow: 'hidden' }}>
            {profile.foto_url ? (
               <img src={`${API_BASE_URL.replace('/src/php', '')}/${profile.foto_url}`} alt="Perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
               <User size={20} />
            )}
          </div>
          <div className="user-info">
            <span className="user-name">{profile.nome}</span>
            <span className="user-role">Administrador</span>
          </div>
        </div>
      </div>
    </header>
  );
}
